export default "__VITE_ASSET__BryGUSMD__"